// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  close: () => 'Fermeture',
  error: () => 'Erreur',
  warn: () => 'Avertissement',
  info: () => 'Information',
  confirmation: () => 'Confirmation',
  progressIndeterminate: () => 'En cours',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Entre ' + p['FROM_SECTION'] + ' et ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + ". Aucune section correspondante n'a été trouvée.",
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Appuyez sur Entrée pour sélectionner une valeur.',
  indexer_touchInstructionText: () =>
    "Touchez deux fois et maintenez le toucher pour passer en mode d'opération, puis faites glisser vers le haut ou le bas pour ajuster la valeur.",
  inputPassword_show: () => 'Afficher le mot de passe',
  inputPassword_hide: () => 'Masquer le mot de passe',
  inputPassword_hidden: () => 'Mot de passe masqué',
  formControl_clear: () => 'Effacer',
  formControl_loading: () => 'Chargement en cours',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Longueur maximale de ' + p['MAX_LENGTH'] + ' dépassée.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' caractères restants.',
  formControl_requiredMessageDetail: () => 'Entrez une valeur.',
  select_requiredMessageDetail: () => 'Sélectionnez une valeur.',
  select_noMatchesFound: () => 'Aucune correspondance trouvée.',
  select_oneMatchFound: () => 'Une correspondance a été trouvée',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' correspondances trouvées',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Au moins ' + p['TOTAL_SIZE'] + ' correspondances trouvées',
  selectMultiple_selectedValues: () => 'Valeurs sélectionnées',
  selectMultiple_showSelectedValues: () => 'Affichez uniquement les valeurs sélectionnées.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' valeurs sélectionnées.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Appuyez sur la touche Retour arrière ou Suppr pour enlever la valeur sélectionnée.',
  selectMultiple_apply: () => 'Appliquer',
  selectMultiple_back: () => 'Retour',
  selector_selected: () => 'Case cochée',
  selector_unselected: () => 'Case non cochée',
  userAssistance_learnMore: () => 'En savoir plus',
  userAssistance_required: () => 'Obligatoire',
  filePicker_singleFileUploadError: () => 'Téléchargez un fichier à la fois',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Vous ne pouvez pas télécharger des fichiers de type ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Vous ne pouvez pas télécharger des fichiers de type ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'inconnu',
  filePicker_dropzonePrimaryText: () => 'Glisser-déplacer',
  filePicker_dropzoneSecondaryText: () => 'Sélectionner un fichier ou en déplacer un ici',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Sélectionner ou déplacer des fichiers ici',
  filePicker_addFiles: () => 'Ajouter des fichiers',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Augmenter',
  inputNumber_decrease: () => 'Diminuer',
  inputNumber_converterParseError: () => 'Entrez un nombre.',
  noData_message: () => 'Aucun élément à afficher',
  message_navigationFromMessagesRegion: () =>
    "Accès à la région des messages. Appuyez sur F6 pour revenir à l'élément sélectionné précédent.",
  message_navigationToMessagesRegion: () =>
    'La région des messages en comporte de nouveaux. Appuyez sur F6 pour revenir à la région du message le plus récent.',
  messageToast_allMessagesClosed: () => 'Tous les messages "toast" sont fermés.',
  expandableList_groupCollapse: () => 'Réduit',
  expandableList_groupExpand: () => 'Développé',
  expandableList_expandCollapseInstructionText: () =>
    'Utilisez les touches fléchées pour effectuer un développement ou une réduction',
  list_suggestion: () => 'Suggestion',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Etape ' + p['currentStep'] + ' sur ' + p['numberOfSteps'],
  train_current: () => 'En cours',
  train_visited: () => 'Consulté',
  train_not_visited: () => 'Non consulté',
  train_message_type: () => 'Type de message',
  viz_drillable: () => 'Explorable',
  dataVisualization_stateSelected: () => 'Sélectionné',
  dataVisualization_stateUnselected: () => 'Désélectionné',
  dataVisualization_noData: () => 'Aucune donnée à afficher'
};
export default bundle;
